import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutoAttendantHoliday, AutoAttendantHolidayRef } from '../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable()
export class TeamsAutoAttendantsHolidayResource {
  private _httpClient = inject(HttpClient);

  getAllHolidays(tenantId: string): Observable<AutoAttendantHoliday[]> {
    return this._httpClient.get<AutoAttendantHoliday[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendant-holidays`,
    );
  }

  createHoliday(tenantId: string, autoAttendantHoliday: AutoAttendantHoliday): Observable<AutoAttendantHolidayRef> {
    return this._httpClient.post<AutoAttendantHolidayRef>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendant-holidays`,
      autoAttendantHoliday,
    );
  }

  updateHoliday(tenantId: string, holidayId: string, autoAttendantHoliday: AutoAttendantHoliday): Observable<void> {
    return this._httpClient.put<void>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendant-holidays/${holidayId}`,
      autoAttendantHoliday,
    );
  }

  deleteHoliday(tenantId: string, holidayId: string): Observable<void> {
    return this._httpClient.delete<void>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendant-holidays/${holidayId}`,
    );
  }
}
